<section aria-labelledby="section-title">
  <div class="row">
    <div class="col-sm-10 col-md-8 col-lg-6 mx-auto text-center">
      <h1 id="section-title">{{ 'DIPRSRegistration.session.expired.title' | translate }}</h1>
      <p class="mb-20">
        {{ 'DIPRSRegistration.session.expired.par1' | translate }}
      </p>
      <div class="row td-toolbar">
        <div class="col-sm-6 mx-auto">
          <button type="button" [dipseWebMetricEvent]="'myins:seamless:enrollment:session:restart'" (click)="restart()" class="btn btn-block td-btn-primary-light">
            {{ 'DIPRSRegistration.session.expired.button' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
